import { IonContent, IonIcon, IonPage } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline, closeOutline } from 'ionicons/icons';
import { FC } from 'react';
import { useHistory } from 'react-router';

export interface PillListItem {
  title: string;
  icon: string;
  isIonIcon?: boolean;
  path?: string | null;
  external?: string;
}

interface PillListPageProps {
  className: string;
  title: string;
  titleIcon: string;
  items: PillListItem[];
}

const PillListPage: FC<PillListPageProps> = ({ className, title, titleIcon, items }) => {
  const history = useHistory();

  const handleItemClick = (item: PillListItem) => {
    if (item.external) {
      window.open(item.external, '_blank', 'noopener,noreferrer');
    } else if (item.path) {
      history.push(item.path);
    }
  };

  return (
    <IonPage className={`pill-list-page ${className}`}>
      <IonContent className="pill-list-content">
        <div className="pill-list-layout">
          <div className="pill-list-header">
            <button className="pill-list-btn pill-list-btn--back" onClick={() => history.goBack()} aria-label="Go back">
              <IonIcon icon={chevronBackOutline} />
            </button>
            <div className="pill-list-title">
              <IonIcon icon={titleIcon} />
              <span>{title}</span>
            </div>
          </div>

          <div className="pill-list-items">
            {items.map((item) => (
              <button key={item.title} className="pill-list-pill" onClick={() => handleItemClick(item)}>
                <div className="pill-list-pill__glass" aria-hidden />
                <div className="pill-list-pill__left">
                  {item.isIonIcon ? (
                    <IonIcon icon={item.icon} className="pill-list-pill__icon" />
                  ) : (
                    <IonIcon src={item.icon} className="pill-list-pill__icon" />
                  )}
                  <span className="pill-list-pill__label">{item.title}</span>
                </div>
                <IonIcon icon={chevronForwardOutline} className="pill-list-pill__chevron" />
              </button>
            ))}
          </div>

          <div className="pill-list-footer">
            <button className="pill-list-btn pill-list-btn--close" onClick={() => history.goBack()} aria-label="Close">
              <IonIcon icon={closeOutline} />
            </button>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default PillListPage;
